import React,{useState,useImperativeHandle,forwardRef,useEffect} from 'react'
import { Modal,message,Form,Input, Space,Button } from 'antd';
import { sendVerificationCode,resetPassword } from '@/services/login';
import { ResDataType } from "@/services/ajax";
import usePagination from '@/hooks/usePagAndCommon';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from'react-redux';
import usePagAndCommon from '@/hooks/usePagAndCommon';
 const MerchantList = (props:any,ref:any) => {
    const router = useNavigate();
    const dispatch = useDispatch();
    const [countdown, setCountdown] = useState(0); 
    const [isDisabled, setIsDisabled] = useState(false); 
    const [form] = Form.useForm();
    const { isModalOpen,setIsModalOpen,flag,setFlag } = usePagAndCommon();
    const showModal = () => {
      setIsModalOpen(true);
    };
    
    const handleCancel = () => {
      form.resetFields();
      setIsModalOpen(false);
    };

    const handleSend = () => {
      if (countdown > 0) return; 
      setIsDisabled(true);
      setCountdown(60); 
      
      const timer = setInterval(() => {
        setCountdown(prev => {
          if (prev === 1) {
            clearInterval(timer);
            setIsDisabled(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    };

    const sendCode = async()=>{
      if (!form.getFieldValue('mobile')) {
        message.error('请输入手机号');
        return; 
      }
      const res = await sendVerificationCode({mobile:form.getFieldValue('mobile')}) as ResDataType;
      if (res.code == 0) {
        handleSend();
        message.success('发送成功'); 
      } else {
        message.error(res.message); 
      }
    }

    const changePassword = async () => {
      const value = await form.validateFields();
      const res = await resetPassword(value) as ResDataType; 
      if (res.code == 0) {
        message.success('修改成功,请重新登录');
        setIsModalOpen(false);
        localStorage.removeItem('token');
        localStorage.removeItem('merchantId')
        router('/login');
      } else {
        message.error(res.message);
      }
    }
    useImperativeHandle(ref, () => ({
        open: () => showModal(),
    }))
    return(
        <Modal title="修改密码" open={isModalOpen} okText="确定" cancelText="取消" onOk={()=>{
          changePassword();
        }} onCancel={handleCancel}>
           <Form
              form={form}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 14 }}
              layout="horizontal"
              style={{ maxWidth: 600 }}
              >
              <Form.Item label="手机号" name="mobile" rules={[{ required: true, message: '请输入手机号' }]}>
                <Space size="small">
                  <Input placeholder="请输入手机号" />
                  <Button type="primary" disabled={isDisabled || countdown > 0} onClick={()=>{
                    sendCode();
                  }}>
                     {countdown > 0 ? `${countdown}s后重新发送` : "发送验证码"}
                  </Button>
                </Space>
              </Form.Item>
              <Form.Item label="验证码" name="verificationCode" rules={[{ required: true, message: '请输入验证码' }]}>
                <Input placeholder="请输入验证码" />
              </Form.Item>
              <Form.Item label="新密码" name="password" rules={[{ required: true, message: '请输入新密码' }]}>
                <Input placeholder="请输入新密码" />
              </Form.Item>
          </Form>
        </Modal>
    )
}

export default forwardRef(MerchantList)